import React from 'react';
import { Link } from 'react-router-dom';
import {
  LoginItemWrap,
  LoginItem,
  LoginTitle,
  ButtonStyled,
  HelpText,
} from './Login.style';
import { Title } from './SignUpType.style';

const dividerStyles: React.CSSProperties = {
  boxShadow: 'none',
  background: '#ccc',
  border: 'none',
  height: '1px',
};

interface LoginCardProps {
  children?: React.ReactNode;
  isLoading?: boolean;
  footerContent?: React.ReactNode;
}

const LoginCard: React.FC<LoginCardProps> = ({
  children = null,
  isLoading = false,
  footerContent = null,
}) => (
  <LoginItemWrap>
    <LoginItem>
      <LoginTitle>
        <Title>Log In to ChalkTalk</Title>
      </LoginTitle>
      {children}
      {isLoading ? (
        <ButtonStyled primary>Loading ...</ButtonStyled>
      ) : (
        <Link to="/register/type">
          <ButtonStyled style={{ fontWeight: 'Semi bold' }} type="button" primary>
            Create account
          </ButtonStyled>
        </Link>
      )}
      <hr style={dividerStyles} />
      {footerContent}
      <HelpText>
        If you are experiencing issues logging in, please inform your teacher.
      </HelpText>
    </LoginItem>
  </LoginItemWrap>
);

export default LoginCard;

